<template>
  <div>
    <Aguarde :show="httpAguarde"/>
    <div v-show="isLoading" class="skeleton-wrap">

      <!-- Header -->
      <div class="sk-header">
        <div>
          <div class="sk-box" style="width: 140px; height: 28px; margin-bottom: 8px;"/>
          <div class="sk-box" style="width: 260px; height: 14px;"/>
        </div>
        <div class="sk-box" style="width: 130px; height: 32px; border-radius: 999px;"/>
      </div>

      <!-- Empresa Row -->
      <div class="sk-empresa">
        <div style="display: flex; align-items: center; gap: 12px;">
          <div class="sk-box" style="width: 36px; height: 36px; border-radius: 9px; flex-shrink: 0;"/>
          <div>
            <div class="sk-box" style="width: 80px; height: 11px; margin-bottom: 6px;"/>
            <div class="sk-box" style="width: 200px; height: 14px; margin-bottom: 5px;"/>
            <div class="sk-box" style="width: 260px; height: 12px;"/>
          </div>
        </div>
        <div class="sk-box" style="width: 140px; height: 34px; border-radius: 7px;"/>
      </div>

      <!-- Métricas -->
      <div class="sk-metrics">
        <div class="sk-metric" v-for="n in 6" :key="n">
          <div class="sk-box" style="width: 36px; height: 36px; border-radius: 9px;"/>
          <div style="margin-top: 10px;">
            <div class="sk-box" style="width: 90px; height: 11px; margin-bottom: 8px;"/>
            <div class="sk-box" style="width: 70px; height: 22px; margin-bottom: 6px;"/>
            <div class="sk-box" style="width: 110px; height: 11px;"/>
          </div>
          <div class="sk-box" style="width: 130px; height: 11px; margin-top: auto;"/>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="sk-charts">
        <div class="sk-chart sk-chart--wide">
          <div class="sk-chart-header">
            <div>
              <div class="sk-box" style="width: 160px; height: 14px; margin-bottom: 6px;"/>
              <div class="sk-box" style="width: 100px; height: 12px;"/>
            </div>
            <div style="text-align: right;">
              <div class="sk-box" style="width: 70px; height: 11px; margin-bottom: 6px; margin-left: auto;"/>
              <div class="sk-box" style="width: 110px; height: 16px; margin-left: auto;"/>
            </div>
          </div>
          <div class="sk-chart-body">
            <div class="sk-bars">
              <div class="sk-bar-line" v-for="(h, i) in lineHeights" :key="i" :style="{ height: h + 'px' }"/>
            </div>
            <div class="sk-line-axis">
              <div class="sk-box sk-axis-label" v-for="n in 12" :key="n"/>
            </div>
          </div>
        </div>

        <div class="sk-chart">
          <div class="sk-chart-header">
            <div>
              <div class="sk-box" style="width: 160px; height: 14px; margin-bottom: 6px;"/>
              <div class="sk-box" style="width: 100px; height: 12px;"/>
            </div>
          </div>
          <div class="sk-chart-body">
            <div class="sk-bars sk-bars--bar">
              <div class="sk-bar-col" v-for="(h, i) in barHeights" :key="i" :style="{ height: h + 'px' }"/>
            </div>
            <div class="sk-bar-axis">
              <div class="sk-box sk-axis-label" v-for="n in 5" :key="n"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabela notas -->
      <div class="sk-table mb-section">
        <div class="sk-table-header">
          <div class="sk-box" style="width: 160px; height: 14px;"/>
          <div class="sk-box" style="width: 60px; height: 12px;"/>
        </div>
        <div class="sk-table-head-row">
          <div class="sk-box" v-for="n in 5" :key="n" style="height: 11px; flex: 1;"/>
        </div>
        <div class="sk-table-row" v-for="n in 6" :key="n">
          <div class="sk-box" style="width: 100px; height: 13px;"/>
          <div class="sk-box" style="flex: 1; height: 13px;"/>
          <div class="sk-box" style="width: 80px; height: 13px;"/>
          <div class="sk-box" style="width: 90px; height: 13px;"/>
          <div class="sk-box" style="width: 70px; height: 22px; border-radius: 999px;"/>
        </div>
      </div>

      <!-- Tabela DUAM -->
      <div class="sk-table">
        <div class="sk-table-header">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div class="sk-box" style="width: 130px; height: 14px;"/>
            <div class="sk-box" style="width: 70px; height: 20px; border-radius: 999px;"/>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <div class="sk-box" style="width: 90px; height: 12px;"/>
            <div class="sk-box" style="width: 80px; height: 14px;"/>
          </div>
        </div>
        <div class="sk-table-head-row">
          <div class="sk-box" v-for="n in 5" :key="n" style="height: 11px; flex: 1;"/>
        </div>
        <div class="sk-table-row" v-for="n in 5" :key="n">
          <div class="sk-box" style="width: 60px; height: 13px;"/>
          <div class="sk-box" style="width: 100px; height: 13px;"/>
          <div class="sk-box" style="width: 80px; height: 13px;"/>
          <div class="sk-box" style="width: 80px; height: 13px;"/>
          <div class="sk-box" style="width: 80px; height: 30px; border-radius: 7px;"/>
        </div>
      </div>

    </div>
    <div v-show="!isLoading" class="dashboard">
      <!-- Header -->
      <div class="dashboard-header">
        <div class="header-left">
          <h1 v-if="empresa && empresa.eco_codigo && !isAdmin" class="dashboard-title">Painel</h1>
          <h1 v-else class="dashboard-title">Painel Geral</h1>
          <p class="dashboard-sub">{{ currentDate }}</p>
        </div>
        <div class="header-right">
          <span class="badge-live">
            <span class="live-dot"/>
            Atualizado agora
          </span>
        </div>
      </div>

      <!-- Alerta Divergência Simples Nacional -->
      <div v-if="periodo_divergente > 0 && !isAdmin" class="alert-divergencia-simples">
        <div class="alert-divergencia-simples__left">
          <div class="alert-divergencia-simples__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </div>
          <div class="alert-divergencia-simples__info">
            <div class="alert-divergencia-simples__top">
              <span class="alert-divergencia-simples__title">Divergências no Simples Nacional</span>
            </div>
            <p class="alert-divergencia-simples__desc">
              {{ periodo_divergente === 1
                ? 'Foi encontrada 1 divergência na apuração do Simples Nacional.'
                : `Foram encontradas ${periodo_divergente} divergências na apuração do Simples Nacional.`
              }}
              <span class="alert-divergencia-simples__highlight">Regularize e evite notificações e multas.</span>
            </p>
          </div>
        </div>
        <button class="alert-divergencia-simples__btn" @click="$router.push({ name: 'contribuinte-simples-fiscalizacao' })">
          <span>Verificar</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>

      <!-- Empresa Selecionada -->
      <div v-if="empresa && empresa.eco_codigo && !isAdmin" class="empresa-row">
        <div class="empresa-row__card">
          <div class="empresa-row__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1" y="4" width="14" height="10" rx="1.5" stroke="currentColor" stroke-width="1.3"/>
              <path d="M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1" stroke="currentColor" stroke-width="1.3"/>
              <path d="M1 8h14" stroke="currentColor" stroke-width="1.3"/>
            </svg>
          </div>
          <div class="empresa-row__info">
            <span class="empresa-row__label">Empresa selecionada</span>
            <div class="empresa-row__linha1">
              <span class="empresa-row__razao">{{ empresa.pes_nome }}</span>
              <span class="empresa-row__cnpj">{{ empresa.pes_cpfcnpj | cpfCnpj }}</span>
            </div>
            <span class="empresa-row__fantasia" v-if="empresa.eco_nome_fantasia">{{ empresa.eco_nome_fantasia }}</span>
          </div>
        </div>
        <button class="empresa-row__btn" @click="getFichaCadastro()">
          <svg width="13" height="13" viewBox="0 0 15 15" fill="none">
            <rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/>
            <path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
          </svg>
          Ficha de Cadastro
        </button>
      </div>
      <div v-else class="empresa-row">
        <div class="empresa-row__card">
          <div class="empresa-row__icon">
            <svg width="13" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/>
              <path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="empresa-row__info">
            <span class="metric-label">Total de Notas Emitidas Hoje</span>
            <div class="empresa-row__linha1">
              <span class="empresa-row__razao">{{ total_notas_emitidas_hoje }}</span>
            </div>
          </div>
        </div>
        <button class="empresa-row__btn" @click="handleVisualizarNotasGeral()">
          <svg width="13" height="13" viewBox="0 0 15 15" fill="none">
            <rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/>
            <path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
          </svg>
          Lista de Notas Fiscais
        </button>
      </div>
      <!-- Métricas principais -->
      <div class="metrics-grid">
        <div class="metric-card" v-for="metric in metrics" :key="metric.key" :class="`metric-card--${metric.color}`">
          <div class="metric-icon">
            <span v-html="metric.icon"/>
          </div>
          <div class="metric-body">
            <p class="metric-label">{{ metric.label }}</p>
            <p class="metric-value">{{ metric.value }}</p>
            <p class="metric-sub" v-if="metric.sub">{{ metric.sub }}</p>
          </div>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="charts-grid">

        <div class="chart-card chart-card--wide">
          <div class="chart-header">
            <div>
              <p class="chart-title">Faturamento Mensal</p>
              <p class="chart-sub">Últimos 12 meses</p>
            </div>
            <div class="chart-total">
              <p class="chart-total-label">Total no período</p>
              <p class="chart-total-value">{{ totalMonthly }}</p>
            </div>
          </div>
          <div ref="lineChart" class="chart-container"/>
        </div>

        <div class="chart-card chart-card--wide">
          <div class="chart-header">
            <div>
              <p class="chart-title">Faturamento Acumulado</p>
              <p class="chart-sub">Últimos 5 anos</p>
            </div>
            <div class="chart-total">
              <p class="chart-total-label">Total acumulado</p>
              <p class="chart-total-value">{{ totalYearly }}</p>
            </div>
          </div>
          <div ref="barChart" class="chart-container"/>
        </div>
      </div>

      <!-- Últimas notas emitidas -->
      <div v-if="ultimasNotas && ultimasNotas.length > 0" class="table-card mb-section">
        <div class="table-header">
          <p class="chart-title">Últimas Notas Emitidas</p>
          <button class="btn-link" @click="$router.push({ name: 'contribuinte-nota-fiscal-lista' })">Ver todas</button>
        </div>
        <div class="table-wrapper">
          <table class="nf-table">
            <thead>
            <tr>
              <th>Número</th>
              <th>Destinatário</th>
              <th>Emissão</th>
              <th class="th-right">Valor</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="nota in ultimasNotas" :key="nota.numero">
              <td class="td-mono">
                <router-link tag="a"
                             :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: nota.not_hash}}">
                  {{ nota.numero }}
                </router-link>
              </td>
              <td>{{ nota.destinatario }}</td>
              <td class="td-muted">{{ nota.emissao }}</td>
              <td class="td-mono td-right">{{ nota.valor }}</td>
              <td>
                <span v-show="!nota.status" class="status-badge status-badge--autorizada">
                    {{ statusLabel(nota.status) }}
                  </span>
                <span v-show="nota.status ==='3'" class="status-badge status-badge--cancelada">
                    {{ statusLabel(nota.status) }}
                  </span>
                <span v-show="nota.status ==='1'" class="status-badge status-badge--pendente">
                    {{ statusLabel(nota.status) }}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="empty-state" v-if="ultimasNotas.length === 0">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
              <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p>Nenhuma nota emitida</p>
          </div>
        </div>
      </div>

      <!-- DUAM em Aberto -->
      <div v-if="duamsEmAberto && duamsEmAberto.length > 0" class="table-card">
        <div class="table-header">
          <div class="header-left-group">
            <p class="chart-title">DUAM em Aberto</p>
            <span class="badge-count">{{ duamsEmAberto.length }} registros</span>
          </div>
          <div class="header-right-group">
            <button class="btn-link" @click="$router.push({ name: 'contribuinte-financeiro-guia' })">Ver todas</button>
          </div>
        </div>
        <div class="table-wrapper">
          <table class="nf-table">
            <thead>
            <tr>
              <th>Número</th>
              <th>Vencimento</th>
              <th class="th-right">Valor Original</th>
              <th class="th-right">
                Valor Atualizado
                <span class="th-info" title="Valor com juros e multa atualizados">ⓘ</span>
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="duam in duamsEmAberto"
                :key="duam.numero"
                :class="{ 'row--vencida': isVencida(duam.vencimento) }"
            >
              <td class="td-numero">{{ duam.numero }}</td>
              <td>
                  <span class="vencimento-wrap">
                    {{ duam.vencimento }}
                    <span class="tag-vencida" v-if="isVencida(duam.vencimento)">Vencida</span>
                  </span>
              </td>
              <td class="td-right">{{ formatCurrency(duam.valorOriginal) }}</td>
              <td class="td-right">
                  <span class="valor-atualizado"
                        :class="{ 'valor--acrescido': duam.valorAtualizado > duam.valorOriginal }">
                    {{ formatCurrency(duam.valorAtualizado) }}
                  </span>
              </td>
              <td class="td-action">
                <button class="btn-visualizar" @click="handleVisualizarDuam(duam)">Visualizar</button>
              </td>
            </tr>
            </tbody>
            <tfoot v-if="duamsEmAberto.length > 0">
            <tr>
              <td colspan="2" class="tf-label">Total</td>
              <td class="tf-value td-right">{{ totalDuamOriginal }}</td>
              <td class="tf-value td-right">{{ totalDuamAtualizado }}</td>
              <td></td>
            </tr>
            </tfoot>
          </table>
          <div class="empty-state" v-if="duamsEmAberto.length === 0">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
              <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p>Nenhum DUAM em aberto</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getPainelBase} from "@/api/core/painel";
import {impressao} from "@/helps/impressao";
import {RelFichaCadastro} from "@/api/relatorio/contribuinte";
import Aguarde from "@/components/widgets/aguarde.vue";
import {listPeriodoDivergencia} from "@/api/simples_nacional/apuracao";

export default {
  name: 'NotaFiscalDashboard',
  components: {Aguarde},
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // Skeleton
      lineHeights: [90, 110, 95, 130, 150, 160, 200, 185, 105, 140, 165, 175],
      barHeights: [140, 175, 210, 240, 100],

      // Estado
      isLoading: true,
      httpAguarde: false,

      // Charts
      lineChartInstance: null,
      barChartInstance: null,
      resizeObserver: null,

      // Auth
      user: null,
      empresa: null,

      // Alerta
      periodo_divergente: 0,
      cancelamentosPendentes: 0,


      total_notas_emitidas_hoje: 0,

      // Gráfico mensal
      monthlyLabels: [],
      monthlyData: [],
      monthlyQtd: [],
      monthlyTicket: [],

      // Gráfico anual
      yearlyLabels: [],
      yearlyData: [],
      yearlyQtd: [],
      yearlyTicket: [],
      yearlyAcumulado: [],
      yearlyVariacao: [],

      // Tabelas
      ultimasNotas: [],
      duamsEmAberto: [],

      // Métricas
      metrics: [],
    };
  },
  created() {
    if (this.isAdmin) {
      this.getBase(0);
    } else {
      this.user = this.$store.state.auth.currentUser;
      this.empresa = this.$store.state.auth.currenEmpresa;
      if (this.empresa && this.empresa.eco_codigo) {
        this.getBase(this.empresa.eco_codigo);
        this.listPeriodoDivergente();
      } else {
        this.getBase(0);
      }
    }
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
    this.lineChartInstance?.dispose();
    this.barChartInstance?.dispose();
  },
  computed: {
    currentDate() {
      return new Date().toLocaleDateString('pt-BR', {
        weekday: 'long', day: '2-digit', month: 'long', year: 'numeric',
      });
    },
    totalMonthly() {
      if (!this.monthlyData.length) return 'R$ 0,00';
      return this.monthlyData
          .reduce((a, b) => a + b, 0)
          .toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    },
    totalYearly() {
      if (!this.yearlyAcumulado.length) return 'R$ 0,00';
      const ultimo = this.yearlyAcumulado[this.yearlyAcumulado.length - 1];
      return Number(ultimo).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    },
    totalDuamOriginal() {
      return this.formatCurrency(this.duamsEmAberto.reduce((s, d) => s + d.valorOriginal, 0));
    },
    totalDuamAtualizado() {
      return this.formatCurrency(this.duamsEmAberto.reduce((s, d) => s + d.valorAtualizado, 0));
    },
  },
  methods: {
    async getBase(eco_codigo) {
      this.isLoading = true;
      try {
        await Promise.all([
          this.getBaseDados(eco_codigo),
        ]);
      } catch (error) {
        console.error('Erro ao carregar painel:', error);
      } finally {
        this.isLoading = false;
        this.$nextTick(() => {
          this.initLineChart();
          this.initBarChart();  // ← só inicializa após todos os dados chegarem
          this.observeResize();
          setTimeout(() => {
            this.lineChartInstance?.resize();
            this.barChartInstance?.resize();
          }, 100);
        });
      }
    },
    async getBaseDados(eco_codigo) {
      const result = await getPainelBase(eco_codigo);
      if (!result.status) return;
      const d = result.dados.metricas;
      this.total_notas_emitidas_hoje = Number(d.total_notas_emitidas_hoje ?? 0).toLocaleString('pt-BR');


      // ── Métricas ──
      this.metrics = [
        {
          key: 'emitidas',
          label: 'Notas Emitidas',
          value: Number(d.total_notas_emitidas ?? 0).toLocaleString('pt-BR'),
          sub: `notas ativas: ${(Number(d.notas_ativas) ?? 0).toLocaleString('pt-BR')}`,
          icon: this.iconDoc(),
          color: 'blue',
        },
        {
          key: 'faturamento',
          label: 'Faturamento do Mês',
          value: Number(d.faturamento_mes_atual ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          sub: `competência ${this.mesAtual()}`,
          icon: this.iconMoney(),
          color: 'green',
        },
        {
          key: 'ticket',
          label: 'Ticket Médio',
          value: Number(d.ticket_medio_mes_atual ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          sub: `por nota emitida ${this.mesAtual()}`,
          icon: this.iconChart(),
          color: 'teal',
        },
        {
          key: 'duam',
          label: 'DUAM em Aberto',
          value: Number(d.duam_em_aberto ?? 0).toLocaleString('pt-BR'),
          sub: Number(d.valor_total_duam_em_aberto ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          icon: this.iconReturn(),
          color: 'coral',
        },
      ];
      // ── Últimas notas ──
      this.ultimasNotas = (result.dados.ultimas_notas ?? []).map(n => ({
        numero: n.not_numero,
        destinatario: n.sep_razao_social_tomador,
        emissao: new Date(n.not_emissao).toLocaleDateString('pt-BR'),
        valor: Number(n.sep_valor).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
        status: n.soc_status_nota,
        not_hash: n.not_hash
      }));
      // ── DUAM ──
      this.duamsEmAberto = (result.dados.duam_aberto ?? []).map(item => ({
        numero: item.dam_codigo,
        vencimento: new Date(item.dam_data_venc_atu).toLocaleDateString('pt-BR'),
        valorOriginal: Number(item.dut_valortributo),
        valorAtualizado: Number(item.dut_valortotal),
        dam_hash: item.dam_hash,
      }));
      this.monthlyLabels = result.dados.faturamento.map(d => d.mes);
      this.monthlyData = result.dados.faturamento.map(d => Number(d.faturamento_total));
      this.monthlyQtd = result.dados.faturamento.map(d => Number(d.quantidade_notas));
      this.monthlyTicket = result.dados.faturamento.map(d => Number(d.ticket_medio));

      this.yearlyLabels = result.dados.faturamento_anual.map(d => d.ano);
      this.yearlyData = result.dados.faturamento_anual.map(d => Number(d.faturamento_total) || 0);
      this.yearlyQtd = result.dados.faturamento_anual.map(d => Number(d.quantidade_notas) || 0);
      this.yearlyTicket = result.dados.faturamento_anual.map(d => Number(d.ticket_medio) || 0);
      this.yearlyAcumulado = result.dados.faturamento_anual.map(d => Number(d.faturamento_acumulado) || 0);
      this.yearlyVariacao = result.dados.faturamento_anual.map(d =>
          d.variacao_percentual !== null ? Number(d.variacao_percentual) : null
      );
    },
    listPeriodoDivergente() {
      this.httpSend = true;
      listPeriodoDivergencia(this.empresa.eco_codigo).then(result => {
        const d = result.dados;
        this.periodo_divergente = d.apuracoes.length;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    // ─── Ficha cadastro ───────────────────────────────────
    getFichaCadastro() {
      this.httpAguarde = true;
      impressao(RelFichaCadastro(this.user.aut_hash, this.empresa.eco_codigo), 'D')
          .catch(error => console.error(error))
          .finally(() => {
            this.httpAguarde = false;
          });
    },
    // ─── Context menu ─────────────────────────────────────
    openContextMenu(event, item) {
      event.preventDefault();
      this.contextMenu = {visible: true, x: event.clientX, y: event.clientY, item};
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
    },
    formatAxisValue(value) {
      const num = Number(value);
      if (isNaN(num) || num === 0) return 'R$ 0';
      const abs = Math.abs(num);
      if (abs >= 1000000) return 'R$ ' + (num / 1000000).toFixed(1) + 'M';
      if (abs >= 1000) return 'R$ ' + (num / 1000).toFixed(1) + 'k';
      return 'R$ ' + num.toFixed(0);
    },
    // ─── Gráfico de linha ─────────────────────────────────
    initLineChart() {
      this.lineChartInstance?.dispose();
      if (!this.$refs.lineChart) return;

      this.lineChartInstance = echarts.init(this.$refs.lineChart);
      this.lineChartInstance.setOption({
        animation: true,
        animationDuration: 1200,
        animationEasing: 'cubicOut',
        animationDurationUpdate: 800,
        animationEasingUpdate: 'cubicInOut',
        legend: {
          data: ['Faturamento', 'Qtd. Notas', 'Ticket Médio'],
          bottom: 0,
          textStyle: {color: '#64748b', fontSize: 11, fontFamily: 'DM Sans, sans-serif'},
          itemWidth: 16,
          itemHeight: 3,
          icon: 'roundRect',
        },

        tooltip: {
          trigger: 'axis',
          backgroundColor: '#1e293b',
          borderColor: '#334155',
          borderWidth: 0.5,
          textStyle: {color: '#e2e8f0', fontSize: 12, fontFamily: 'DM Sans, sans-serif'},
          formatter: (params) => {
            const mes = params[0].name;
            const fat = Number(params[0]?.value ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
            const qtd = Number(params[1]?.value ?? 0).toLocaleString('pt-BR');
            const tkt = Number(params[2]?.value ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
            return `
          <div style="font-size:11px;color:#94a3b8;margin-bottom:8px;font-weight:500">${mes}</div>
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span style="display:inline-block;width:10px;height:3px;background:#3b82f6;border-radius:2px"></span>
            <span style="color:#94a3b8;font-size:11px">Faturamento</span>
            <span style="margin-left:auto;font-weight:600">${fat}</span>
          </div>
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span style="display:inline-block;width:10px;height:3px;background:#a855f7;border-radius:2px"></span>
            <span style="color:#94a3b8;font-size:11px">Qtd. Notas</span>
            <span style="margin-left:auto;font-weight:600">${qtd}</span>
          </div>
          <div style="display:flex;align-items:center;gap:6px">
            <span style="display:inline-block;width:10px;height:3px;background:#14b8a6;border-radius:2px"></span>
            <span style="color:#94a3b8;font-size:11px">Ticket Médio</span>
            <span style="margin-left:auto;font-weight:600">${tkt}</span>
          </div>
        `;
          },
        },

        grid: {top: 16, right: 16, bottom: 56, left: 72},

        xAxis: {
          type: 'category',
          data: this.monthlyLabels,
          axisLine: {lineStyle: {color: '#e2e8f0'}},
          axisTick: {show: false},
          axisLabel: {color: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans, sans-serif'},
        },

        yAxis: [
          // Eixo esquerdo — Faturamento e Ticket Médio (R$)
          {
            type: 'value',
            name: 'R$',
            nameTextStyle: {color: '#94a3b8', fontSize: 10},
            splitLine: {lineStyle: {color: '#f1f5f9', type: 'dashed'}},
            axisLabel: {
              color: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans, sans-serif',
              formatter: (v) => 'R$ ' + (v / 1000).toFixed(0) + 'k',
            },
          },
          // Eixo direito — Quantidade de Notas
          {
            type: 'value',
            name: 'Notas',
            nameTextStyle: {color: '#94a3b8', fontSize: 10},
            splitLine: {show: false},
            axisLabel: {
              color: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans, sans-serif',
              formatter: (v) => v,
            },
          },
        ],

        series: [
          // ── Faturamento ──
          {
            name: 'Faturamento',
            type: 'line',
            yAxisIndex: 0,
            data: this.monthlyData,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            animationDelay: 0,
            animationDuration: 1200,
            animationEasing: 'cubicInOut',
            lineStyle: {color: '#3b82f6', width: 2.5},
            itemStyle: {color: '#3b82f6', borderColor: '#fff', borderWidth: 2},
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  {offset: 0, color: 'rgba(59,130,246,0.15)'},
                  {offset: 1, color: 'rgba(59,130,246,0)'},
                ],
              },
            },
          },

          // ── Quantidade de Notas ──
          {
            name: 'Qtd. Notas',
            type: 'line',
            yAxisIndex: 1,
            data: this.monthlyQtd,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            animationDelay: 0,
            animationDuration: 1200,
            animationEasing: 'cubicInOut',
            lineStyle: {color: '#a855f7', width: 2, type: 'dashed'},
            itemStyle: {color: '#a855f7', borderColor: '#fff', borderWidth: 2},
          },

          // ── Ticket Médio ──
          {
            name: 'Ticket Médio',
            type: 'line',
            yAxisIndex: 0,
            data: this.monthlyTicket,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            animationDelay: 0,
            animationDuration: 1200,
            animationEasing: 'cubicInOut',
            lineStyle: {color: '#14b8a6', width: 2},
            itemStyle: {color: '#14b8a6', borderColor: '#fff', borderWidth: 2},
          },
        ],
      });
    },
    // ─── Gráfico de barra ─────────────────────────────────
    initBarChart() {
      this.barChartInstance?.dispose();
      if (!this.$refs.barChart) return;
      this.barChartInstance = echarts.init(this.$refs.barChart, null, {
        renderer: 'canvas', width: 'auto', height: 260,
      });
      this.barChartInstance.setOption({
        animationDuration: 800,
        animationEasing: 'elasticOut',  // efeito elástico nas barras
        animationDurationUpdate: 800,
        animationEasingUpdate: 'cubicInOut',
        animationDelay: (idx) => idx * 100,
        legend: {
          data: ['Faturamento', 'Ticket Médio', 'Qtd. Notas'],
          bottom: 0,
          textStyle: {color: '#64748b', fontSize: 11, fontFamily: 'DM Sans, sans-serif'},
          itemWidth: 16,
          itemHeight: 3,
          icon: 'roundRect',
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#1e293b',
          borderColor: '#334155',
          borderWidth: 0.5,
          textStyle: {color: '#e2e8f0', fontSize: 12, fontFamily: 'DM Sans, sans-serif'},
          formatter: (params) => {
            const ano = params[0]?.name ?? '';
            const fat = Number(params[0]?.value ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
            const tkt = Number(params[1]?.value ?? 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
            const qtd = Number(params[2]?.value ?? 0).toLocaleString('pt-BR');

            const idx = (this.yearlyLabels || []).indexOf(ano);
            const variac = idx >= 0 && this.yearlyVariacao ? this.yearlyVariacao[idx] : null;
            const varStr = variac !== null && variac !== undefined
                ? `<span style="color:${variac >= 0 ? '#22c55e' : '#ef4444'};font-weight:600">${variac >= 0 ? '▲' : '▼'} ${Math.abs(variac)}%</span> vs ano anterior`
                : '<span style="color:#64748b">Primeiro ano</span>';
            return `
          <div style="font-size:11px;color:#94a3b8;margin-bottom:8px;font-weight:500">${ano} ${varStr}</div>
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span style="display:inline-block;width:10px;height:10px;background:#3b82f6;border-radius:2px"></span>
            <span style="color:#94a3b8;font-size:11px">Faturamento</span>
            <span style="margin-left:auto;font-weight:600">${fat}</span>
          </div>
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px">
            <span style="display:inline-block;width:10px;height:3px;background:#14b8a6;border-radius:2px"></span>
            <span style="color:#94a3b8;font-size:11px">Ticket Médio</span>
            <span style="margin-left:auto;font-weight:600">${tkt}</span>
          </div>
          <div style="display:flex;align-items:center;gap:6px">
            <span style="display:inline-block;width:10px;height:3px;background:#a855f7;border-radius:2px;border-top:2px dashed #a855f7"></span>
            <span style="color:#94a3b8;font-size:11px">Qtd. Notas</span>
            <span style="margin-left:auto;font-weight:600">${qtd}</span>
          </div>
        `;
          },
        },
        grid: {top: 28, right: 16, bottom: 56, left: 80},
        xAxis: {
          type: 'category',
          data: this.yearlyLabels,
          axisLine: {lineStyle: {color: '#e2e8f0'}},
          axisTick: {show: false},
          axisLabel: {color: '#94a3b8', fontSize: 12, fontFamily: 'DM Sans, sans-serif'},
        },
        yAxis: [
          // Eixo esquerdo — valores R$
          {
            type: 'value',
            name: 'R$',
            nameTextStyle: {color: '#94a3b8', fontSize: 10},
            splitLine: {lineStyle: {color: '#f1f5f9', type: 'dashed'}},
            axisLabel: {
              color: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans, sans-serif',
              formatter: (v) => this.formatAxisValue(v),
            },
          },
          // Eixo direito — quantidade
          {
            type: 'value',
            name: 'Notas',
            nameTextStyle: {color: '#94a3b8', fontSize: 10},
            splitLine: {show: false},
            axisLabel: {
              color: '#94a3b8', fontSize: 11, fontFamily: 'DM Sans, sans-serif',
              formatter: (v) => v,
            },
          },
        ],
        series: [
          // ── Faturamento (barra) ──
          {
            name: 'Faturamento',
            type: 'bar',
            yAxisIndex: 0,
            data: this.yearlyData,  // ← array simples de números, sem objeto
            barMaxWidth: 48,
            borderRadius: [6, 6, 0, 0],
            itemStyle: {
              color: (params) => {
                const isLast = params.dataIndex === this.yearlyData.length - 1;
                return {
                  type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: isLast
                      ? [{offset: 0, color: '#60a5fa'}, {offset: 1, color: '#3b82f6'}]
                      : [{offset: 0, color: '#93c5fd'}, {offset: 1, color: '#bfdbfe'}],
                };
              },
            },
            label: {
              show: true,
              position: 'top',
              color: '#64748b',
              fontSize: 10,
              fontFamily: 'DM Sans, sans-serif',
              formatter: (p) => this.formatAxisValue(Number(p.value) || 0),
            },
          },
          // ── Ticket Médio (linha) ──
          {
            name: 'Ticket Médio',
            type: 'line',
            yAxisIndex: 0,
            data: this.yearlyTicket,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {color: '#14b8a6', width: 2},
            itemStyle: {color: '#14b8a6', borderColor: '#fff', borderWidth: 2},
          },
          // ── Qtd. Notas (linha tracejada eixo direito) ──
          {
            name: 'Qtd. Notas',
            type: 'line',
            yAxisIndex: 1,
            data: this.yearlyQtd,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {color: '#a855f7', width: 2, type: 'dashed'},
            itemStyle: {color: '#a855f7', borderColor: '#fff', borderWidth: 2},
          },
        ],
      });
    },
    // ─── ResizeObserver ───────────────────────────────────
    observeResize() {
      this.resizeObserver = new ResizeObserver(() => {
        this.lineChartInstance?.resize();
        this.barChartInstance?.resize();
      });
      if (this.$refs.lineChart) this.resizeObserver.observe(this.$refs.lineChart);
      if (this.$refs.barChart) this.resizeObserver.observe(this.$refs.barChart);
    },
    // ─── DUAM ─────────────────────────────────────────────
    isVencida(vencimento) {
      const [dia, mes, ano] = vencimento.split('/').map(Number);
      return new Date(ano, mes - 1, dia) < new Date();
    },
    handleVisualizarDuam(guia) {
      this.$router.push({
        name: "contribuinte-financeiro-pagamento",
        params: {dam_hash: guia.dam_hash}
      })
    },
    handleVisualizarNotasGeral() {
      this.$router.push({name: "admin-nfse-consulta"})
    },
    formatCurrency(value) {
      return Number(value || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    },
    // ─── Notas ────────────────────────────────────────────
    statusLabel(s) {
      if (!s) {
        return 'Emitida';
      }
      if (s === '3') {
        return 'Cancelada';
      }
      return 'Pendente';
    },
    // ─── Auxiliares ───────────────────────────────────────
    mesAtual() {
      const meses = [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
      ];
      const d = new Date();
      return `${meses[d.getMonth()]}/${d.getFullYear()}`;
    },
    // ─── Ícones ───────────────────────────────────────────
    iconDoc() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="3" y="2" width="12" height="14" rx="2" stroke="currentColor" stroke-width="1.4"/>
        <path d="M6 6h6M6 9h6M6 12h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>`;
    },
    iconX() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.4"/>
        <path d="M6.5 6.5l5 5M11.5 6.5l-5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>`;
    },
    iconClock() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.4"/>
        <path d="M9 5v4.5l2.5 2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>`;
    },
    iconMoney() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="2" y="5" width="14" height="9" rx="2" stroke="currentColor" stroke-width="1.4"/>
        <circle cx="9" cy="9.5" r="2" stroke="currentColor" stroke-width="1.4"/>
        <path d="M5 5V4M13 5V4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>`;
    },
    iconReturn() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M4 9a5 5 0 1010 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
        <path d="M4 9l2-2M4 9l2 2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    },
    iconChart() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M3 13l4-4 3 3 5-6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    },
  },
};
</script>

<style scoped>
/* ─── Skeleton ───────────────────────────────────────────── */
.skeleton-wrap {
  background: #f8fafc;
  min-height: 100vh;
  padding: 2rem 2.5rem;
}

.sk-box {
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 6px;
  flex-shrink: 0;
}

.sk-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.sk-empresa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 1.5rem;
  margin-bottom: 1.75rem;
  gap: 12px;
}

.sk-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 1.75rem;
}

.sk-metric {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.1rem 1.25rem;
  display: flex;
  flex-direction: column;
  min-height: 140px;
}

.sk-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 1.75rem;
  min-width: 0;
}

.sk-chart {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  min-width: 0;
}

.sk-chart--wide {
  grid-column: span 2;
}

.sk-chart-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.sk-chart-body {
  display: flex;
  flex-direction: column;
  height: 220px;
}

.sk-bars {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  flex: 1;
  padding-bottom: 8px;
}

.sk-bar-line {
  flex: 1;
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 3px 3px 0 0;
  opacity: 0.6;
}

.sk-bars--bar {
  gap: 16px;
  padding: 0 8px 8px;
}

.sk-bar-col {
  flex: 1;
  background: linear-gradient(90deg, #bfdbfe 25%, #dbeafe 50%, #bfdbfe 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 6px 6px 0 0;
}

.sk-line-axis,
.sk-bar-axis {
  display: flex;
  gap: 6px;
  padding-top: 6px;
  border-top: 0.5px solid #f1f5f9;
}

.sk-bar-axis {
  gap: 16px;
  padding: 6px 8px 0;
}

.sk-axis-label {
  flex: 1;
  height: 10px;
  background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 4px;
}

.sk-table {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.sk-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #f1f5f9;
  gap: 8px;
  flex-wrap: wrap;
}

.sk-table-head-row {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 10px 1.5rem;
  background: #f8fafc;
  border-bottom: 0.5px solid #f1f5f9;
}

.sk-table-row {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 14px 1.5rem;
  border-top: 0.5px solid #f1f5f9;
}

/* ─── Base ───────────────────────────────────────────────── */
.dashboard {
  background: #f8fafc;
  min-height: 100vh;
  padding: 1rem 1rem;
  color: #0f172a;
}

/* ─── Header ─────────────────────────────────────────────── */
.dashboard-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.dashboard-title {
  margin: 0 0 2px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #0f172a;
}

.dashboard-sub {
  margin: 0;
  font-size: 13px;
  color: #a4a9af;
  text-transform: capitalize;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* ─── Badge live ─────────────────────────────────────────── */
.badge-live {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 999px;
  padding: 5px 12px;
  white-space: nowrap;
}

.live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
  animation: pulse-dot 2s infinite;
}

/* ─── Empresa Row ────────────────────────────────────────── */
.empresa-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 1.5rem;
  margin-bottom: 1.75rem;
  min-width: 0;
}

.empresa-row__card {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.empresa-row__icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: #eff6ff;
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.empresa-row__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.empresa-row__label {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.empresa-row__linha1 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.empresa-row__razao {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empresa-row__cnpj {
  font-size: 12px;
  font-family: 'DM Mono', monospace;
  color: #64748b;
  white-space: nowrap;
  background: #f1f5f9;
  border-radius: 5px;
  padding: 1px 7px;
}

.empresa-row__fantasia {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empresa-row__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  background: transparent;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.empresa-row__btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

/* ─── Alerta Divergência Simples Nacional ───────────────── */
.alert-divergencia-simples {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #fff8f8 0%, #ffffff 100%);
  border: 1px solid #fee2e2;
  border-left: 4px solid #ef4444;
  border-radius: 10px;
  padding: 14px 1.5rem;
  margin-bottom: 1.75rem;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.07);
  min-width: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.alert-divergencia-simples:hover {
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.12);
}

.alert-divergencia-simples__left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1;
}

.alert-divergencia-simples__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fee2e2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.alert-divergencia-simples__info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.alert-divergencia-simples__top {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.alert-divergencia-simples__badge {
  font-size: 10px;
  font-weight: 700;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 2px 7px;
  border-radius: 4px;
}

.alert-divergencia-simples__title {
  font-size: 13px;
  font-weight: 700;
  color: #991b1b;
}

.alert-divergencia-simples__desc {
  margin: 0;
  font-size: 13px;
  color: #7f1d1d;
  line-height: 1.4;
}

.alert-divergencia-simples__highlight {
  color: #dc2626;
  font-weight: 600;
}

.alert-divergencia-simples__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  background: #dc2626;
  border: 1px solid #dc2626;
  border-radius: 7px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);
}

.alert-divergencia-simples__btn:hover {
  background: #b91c1c;
  border-color: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.25);
}

.alert-divergencia-simples__btn:active {
  transform: scale(0.97);
}

/* ─── Alerta cancelamentos ───────────────────────────────── */
.alert-cancelamento {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1rem 1.25rem;
}

.alert-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.alert-body {
  flex: 1;
  min-width: 0;
}

.alert-title {
  margin: 0 0 3px;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.alert-desc {
  margin: 0;
  font-size: 13px;
  color: #b45309;
  line-height: 1.5;
}

.alert-desc strong {
  font-weight: 600;
  color: #92400e;
}

.alert-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-cancelamento {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f59e0b;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, transform 0.1s;
}

.btn-cancelamento:hover {
  background: #d97706;
}

.btn-cancelamento:active {
  transform: scale(0.97);
}

.btn-fechar-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: background 0.15s;
}

.btn-fechar-alert:hover {
  background: #fde68a;
}

/* ─── Métricas ───────────────────────────────────────────── */
.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 1.75rem;
}

.metric-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: box-shadow 0.15s;
}

.metric-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.metric-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metric-card--blue .metric-icon {
  background: #eff6ff;
  color: #3b82f6;
}

.metric-card--red .metric-icon {
  background: #fef2f2;
  color: #ef4444;
}

.metric-card--amber .metric-icon {
  background: #fffbeb;
  color: #f59e0b;
}

.metric-card--green .metric-icon {
  background: #f0fdf4;
  color: #22c55e;
}

.metric-card--coral .metric-icon {
  background: #fff7ed;
  color: #f97316;
}

.metric-card--teal .metric-icon {
  background: #f0fdfa;
  color: #14b8a6;
}

.metric-label {
  margin: 0 0 2px;
  font-size: 12px;
  color: #94a3b8;
}

.metric-value {
  margin: 0 0 2px;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: #0f172a;
}

.metric-sub {
  margin: 0;
  font-size: 11px;
  color: #a4a9af;
}

/* ─── Gráficos ───────────────────────────────────────────── */
.charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 1.75rem;
  min-width: 0;
}

.chart-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  min-width: 0;
}

.chart-card--wide {
  grid-column: span 2;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.chart-title {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.chart-sub {
  margin: 0;
  font-size: 12px;
  color: #a4a9af;
}

.chart-total {
  text-align: right;
}

.chart-total-label {
  margin: 0 0 2px;
  font-size: 11px;
  color: #a4a9af;
}

.chart-total-value {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  letter-spacing: -0.02em;
}

.chart-container {
  height: 260px;
  width: 100%;
}

/* ─── Tabelas ────────────────────────────────────────────── */
.table-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.mb-section {
  margin-bottom: 1.75rem;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 8px;
}

.header-left-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-right-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.badge-count {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 2px 9px;
}

.btn-link {
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.btn-link:hover {
  text-decoration: underline;
}

.table-wrapper {
  overflow-x: auto;
}

.nf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.nf-table thead tr {
  background: #f8fafc;
}

.nf-table th {
  padding: 9px 1.5rem;
  text-align: left;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.th-right {
  text-align: right;
}

.th-info {
  cursor: help;
  color: #94a3b8;
  font-size: 12px;
  margin-left: 4px;
}

.nf-table td {
  padding: 12px 1.5rem;
  border-top: 0.5px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.nf-table tr:hover td {
  background: #f8fafc;
}

.td-mono {
  font-size: 12px;
  color: #475569;
}

.td-muted {
  color: #94a3b8;
}

.td-right {
  text-align: right;
}

.td-numero {
  font-weight: 600;
  color: #0f172a;
}

.td-action {
  text-align: right;
  white-space: nowrap;
}

.row--vencida td {
  background: #fff8f8;
}

.row--vencida:hover td {
  background: #fef2f2;
}

.vencimento-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tag-vencida {
  font-size: 10px;
  font-weight: 500;
  color: #dc2626;
  background: #fef2f2;
  border: 0.5px solid #fecaca;
  border-radius: 999px;
  padding: 1px 7px;
}

.valor-atualizado {
  font-size: 12px;
  color: #334155;
}

.valor--acrescido {
  color: #dc2626;
  font-weight: 500;
}

.btn-visualizar {
  background: #4f6ef7;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
}

.btn-visualizar:hover {
  background: #3b55e0;
}

.btn-visualizar:active {
  transform: scale(0.97);
}

.nf-table tfoot tr td {
  border-top: 1px solid #e2e8f0;
  padding: 10px 1.5rem;
  background: #f8fafc;
}

.tf-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.tf-value {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
}

.status-badge--autorizada {
  background: #f0fdf4;
  color: #16a34a;
}

.status-badge--cancelada {
  background: #fef2f2;
  color: #dc2626;
}

.status-badge--pendente {
  background: #fffbeb;
  color: #d97706;
}

.status-badge--devolucao {
  background: #fff7ed;
  color: #ea580c;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 3rem;
  color: #94a3b8;
  font-size: 13px;
}

/* ─── Animações ──────────────────────────────────────────── */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.85);
  }
}

.slide-down-enter-active {
  transition: all 0.3s ease;
}

.slide-down-leave-active {
  transition: all 0.25s ease;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ─── Responsivo ─────────────────────────────────────────── */
@media (max-width: 900px) {
  .dashboard {
    padding: 1.25rem;
  }

  .skeleton-wrap {
    padding: 1.25rem;
  }

  .charts-grid {
    grid-template-columns: 1fr;
  }

  .chart-card--wide {
    grid-column: span 1;
  }

  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sk-charts {
    grid-template-columns: 1fr;
  }

  .sk-chart--wide {
    grid-column: span 1;
  }

  .sk-metrics {
    grid-template-columns: repeat(2, 1fr);
  }

  .sk-empresa {
    flex-direction: column;
    align-items: flex-start;
  }

  .alert-cancelamento {
    flex-wrap: wrap;
  }

  .alert-divergencia-simples {
    flex-direction: column;
    align-items: flex-start;
  }

  .alert-divergencia-simples__btn {
    align-self: flex-start;
  }

  .alert-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .empresa-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .empresa-row__btn {
    align-self: flex-start;
  }
}

@media (max-width: 520px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .sk-metrics {
    grid-template-columns: 1fr;
  }
}
</style>